import { SunIcon, MoonIcon } from '@heroicons/react/24/outline'
import { useTheme } from '../domains/auth/ThemeContext'

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg text-gray-500 dark:text-tech-400 hover:text-primary-500 dark:hover:text-primary-400 transition-colors duration-200 hover:bg-gray-100/50 dark:hover:bg-tech-700/50"
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? (
        <SunIcon className="h-5 w-5" />
      ) : (
        <MoonIcon className="h-5 w-5" />
      )}
    </button>
  )
} 